export const list = {
  table: {
    quantity: '投入量(ケース数）',
    createdAt: '投入日/時間',
  },
  pageHeader: {
    title: '洗剤タンクリスト　洗剤タンク詳細画面',
    tankTitle: '投入履歴',
    new: '新規追加',
  },
}
